import { z } from "zod";
export const preciseUnitMoneySchema = z.string().regex(/^(0|[1-9]\d{0,15})(\.\d{1,6})?$/);
/** Exact acquisition principals; admitted only by the explicit publication item branch. */
export const acquisitionPrincipalMoneySchema = z.string().regex(/^(0|[1-9]\d{0,15})(\.\d{1,80})?$/);
export const monetaryBasisInputSchema = z
    .object({
    type: z.enum(["UNIT", "LINE_TOTAL"]),
    /** Commercial unit as declared, e.g. UN or CX. No packaging conversion is inferred. */
    commercialUnit: z.string().trim().min(1).max(40),
})
    .strict();
/** All monetary result fields, including legacy-named landedUnitCost, are LINE TOTALS. */
export const monetaryBasisResultSchema = z
    .object({
    type: z.literal("LINE_TOTAL"),
    sourceType: monetaryBasisInputSchema.shape.type,
    commercialUnit: monetaryBasisInputSchema.shape.commercialUnit,
    quantity: z.number().int().min(1).max(999999999),
    originalBaseCost: acquisitionPrincipalMoneySchema,
    originalSalePrice: preciseUnitMoneySchema.optional(),
})
    .strict();
/** Exact weight of result amounts. Line totals must never be multiplied by quantity again. */
export function calculationAmountMultiplier(input, result) {
    if (result.monetaryBasis?.type === "LINE_TOTAL")
        return 1n;
    const quantity = input.quantity ?? 1;
    return BigInt(Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1);
}
//# sourceMappingURL=monetary-basis.js.map